import { render, staticRenderFns } from "./AppNavbarPublicLayoutMenu.vue?vue&type=template&id=650cfcf4&"
import script from "./AppNavbarPublicLayoutMenu.vue?vue&type=script&lang=js&"
export * from "./AppNavbarPublicLayoutMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports